export default __webpack_public_path__ + "static/media/sorvete.3e550227.jpg";